import axios from 'axios';

export const getStatByComCode = async (comCode, token) => {
  const res = await axios.get(`/api/stats/com/${comCode}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const getStatHistory = async (comCode, token) => {
  const res = await axios.get(`/api/stats/history/${comCode}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};
